import { useEffect } from "react";
import "aos/dist/aos.css";
import "./Specialite.css";
import { FaDog, FaEye, FaAward, FaBolt } from "react-icons/fa";

export default function Specialite() {
  useEffect(() => {
    const AOS = require("aos");
    AOS.init({
      duration: 800,
      once: true,
      offset: 60,
    });
  }, []);

  const features = [
    {
      icon: <FaBolt />,
      title: "Dissuasion Immédiate",
      desc: "L'impact psychologique du binôme maître-chien neutralise immédiatement les risques d'intrusion et d'agression.",
    },
    {
      icon: <FaEye />,
      title: "Détection Augmentée",
      desc: "Sens olfactifs et auditifs surdéveloppés pour sécuriser les zones sombres, hangars et vastes périmètres.",
    },
    {
      icon: <FaAward />,
      title: "Binôme Certifié & Conforme",
      desc: "Chiens déclarés et entraînés, agents titulaires de la carte professionnelle CNAPS avec carnet vétérinaire à jour.",
    },
  ];

  return (
    <section className="section specialite-section" data-aos="fade-up">
      <div className="specialite-header">
        <span className="section-tag">{"//"} NOTRE SIGNATURE OPÉRATIONNELLE</span>
        <h2 className="section-title">
          Protection d’Élite par <span className="text-gold">Agents Cynophiles</span>
        </h2>
        <p className="specialite-lead">
          Le binôme homme-chien constitue la réponse la plus dissuasive et efficace face aux intrusions,
          au squat et aux actes de vandalisme sur chantiers, entrepôts et sites sensibles.
        </p>
      </div>

      <div className="specialite-grid">
        {features.map((item, index) => (
          <div key={index} className="specialite-card" data-aos="fade-up" data-aos-delay={index * 150}>
            <div className="specialite-icon">{item.icon}</div>
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <div className="specialite-banner">
        <div className="banner-content">
          <FaDog className="banner-dog-icon" />
          <div>
            <strong>Disponibilité d'urgence 24h/24 et 7j/7</strong>
            <p>Déploiement d'agents maîtres-chiens en horaires décalés, nuit, week-ends et jours fériés en Île-de-France.</p>
          </div>
        </div>
        <a href="#contact" className="btn-primary specialite-btn">
          Réserver un agent cynophile
        </a>
      </div>
    </section>
  );
}
